module.exports = __webpack_public_path__ + "static/img/lanya.0ac022c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/lanya.png
// module id = ml5p
// module chunks = 12